import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, Button } from 'react-bootstrap';
import { FaQrcode } from "react-icons/fa6";
import SeasonDetailPage from '../season/SeasonDetailPage';
import LeagueDetailPage from './LeagueDetailPage';
import LeagueQRCodeModal from './LeagueQRCodeModal';

function LeagueManager() {
    const [leagues, setLeagues] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedLeagueId, setSelectedLeagueId] = useState(null);
    const [selectedSeasonId, setSelectedSeasonId] = useState(null);
    const [showQRModal, setShowQRModal] = useState(false);
    const [selectedLeague, setSelectedLeague] = useState(null);
    const [selectedSeason, setSelectedSeason] = useState(null);

    const fetchLeagues = async () => {
        try {
            setLoading(true);
            const response = await fetch('/api/leagues/leagues/', {
                withCredentials: true,
            });
            if (response.ok) {
                const data = await response.json();
                setLeagues(data);
            } else {
                console.error('Failed to fetch leagues:', response.status, response.statusText);
            }
        } catch (error) {
            console.error('Error fetching leagues:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLeagues();
    }, []);

    const handleQRCodeClick = (league) => {
        // Find the nearest open season for this league
        const today = new Date();
        const openSeason = league.seasons.find(season => {
            const startDate = new Date(season.registration_start_date);
            const deadline = new Date(season.registration_deadline);
            return season.registration_open && today >= startDate && today <= deadline;
        });

        if (openSeason) {
            setSelectedLeague(league);
            setSelectedSeason(openSeason);
            setShowQRModal(true);
        } else {
            // Show an alert if no open season is found
            alert('No open registration seasons found for this league.');
        }
    };


    if (loading) {
        return (
            <div className="card">
                <div className="card-body">
                    <div className="text-center">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // 1) If a season is selected, show SeasonDetailPage
    if (selectedSeasonId) {
        return (
            <SeasonDetailPage
                seasonId={selectedSeasonId}
                onBack={() => setSelectedSeasonId(null)} // This resets to show LeagueDetailPage again
            />
        );
    }

    // 2) Otherwise, show either LeagueDetailPage (when a league is selected)
    //    or the list of leagues (when no league is selected).
    return (
        <>
            {selectedLeagueId ? (
                <LeagueDetailPage
                    leagueId={selectedLeagueId}
                    onBack={() => setSelectedLeagueId(null)} // Go back to all leagues
                    onSeasonSelect={(seasonId) => setSelectedSeasonId(seasonId)} // <-- PASS onSeasonSelect HERE
                />
            ) : (
                <div className="card">
                    <div className="card-header border-0 pb-0">
                        <h5 className="card-title">Leagues</h5>
                        <p className="mb-0">View and manage all your leagues here.</p>
                    </div>
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className="mb-0">Existing Leagues</h6>
                            {/* <button
                                className="btn btn-primary btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#addLeagueModal"
                            >
                                Add League
                            </button> */}
                        </div>
                        <ul className="list-group">
                            {leagues.map((league) => (
                                <li
                                    key={league.id}
                                    className="list-group-item d-flex justify-content-between align-items-center"
                                >
                                    <div>
                                        <strong>
                                            <Link
                                                to={`/league-manager/${league.id}/`}
                                                className="text-decoration-none"
                                            >
                                                {league.name}
                                            </Link>
                                        </strong>
                                        <br />
                                        <small>{league.name} League in {league.location}</small>
                                    </div>
                                    <div className="d-flex align-items-center gap-2">
                                        <Button variant="light" size="sm" onClick={() => handleQRCodeClick(league)}>
                                            <FaQrcode className="me-1" />
                                        </Button>
                                        {/* <Dropdown>
                                            <Dropdown.Toggle bsPrefix="dropdown-icon btn-sm" variant="light" id={`league-actions-${league.id}`}>
                                                <i className="bi bi-three-dots"></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => handleQRCodeClick(league)}>
                                                    <FaQrcode className="me-1" /> Registration QR Code
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown> */}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}

            <LeagueQRCodeModal
                show={showQRModal}
                handleClose={() => {
                    setShowQRModal(false);
                }}
                league={selectedLeague}
                season={selectedSeason}
            />
        </>
    );
}

export default LeagueManager;
